var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('a-replace-media-activator',{on:{"replace":_vm.replace}}),_c('a-replace-media-handler',_vm._g({ref:"handler",attrs:{"box":_vm.box}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }